import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

function Login() {
  const [form, setForm] = useState({ admin_id: '', password: '' });
  const navigate = useNavigate();
  const { handleLogin } = useContext(AuthContext);

  const handleLoginClick = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/manager-users/login', form);
      const { token } = res.data;
      handleLogin(token);
      navigate('/');
    } catch (err) {
      console.error('로그인 실패:', err);
      alert('아이디 또는 비밀번호가 올바르지 않습니다');
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 400 }}>
      <h3>🔐 로그인</h3>
      {/* ✅ form 태그로 감싸기 */}
      <form onSubmit={handleLoginClick}>
        <input
          className="form-control mb-2"
          placeholder="아이디"
          value={form.admin_id}
          onChange={(e) => setForm({ ...form, admin_id: e.target.value })}
        />
        <input
          className="form-control mb-2"
          type="password"
          placeholder="비밀번호"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />
        <button type="submit" className="btn btn-primary w-100">
          로그인
        </button>
      </form>
    </div>
  );
}

export default Login;
